import BasePlayerBuilder from 'components/organisms/players-to-exchange/available-players/base-player-builder';
import BuilderInterface from 'components/organisms/players-to-exchange/available-players/builder-interface';
import TableElement from 'components/organisms/players-to-exchange/table-elements/table-element';
import PlayerInterface from 'interfaces/players-data-interfaces/player-interface';
import LineupInterface from 'interfaces/lineups-data-interfaces/lineup-interface';
import React from 'react';

export default class ClassicBuilder extends BasePlayerBuilder implements BuilderInterface {
    getTableHead(): Array<TableElement> {
        const elements = {
            'td-pos': 'Pos',
            'td-name': 'Name',
            'td-salary': 'Salary',
            'td-odds': 'Odds',
            'td-rating': 'Rating',
            'td-fpts': 'Fpts/$',
            'td-fpts-per-salary': 'Fpts',
            'td-pown': 'pOwn%',
            '': '',
        };

        return this.buildRow(elements);
    }

    getTableBody(
        player: PlayerInterface,
        substitutablePlayer: PlayerInterface,
        lineup: LineupInterface,
        salaryCapExceeded: boolean,
    ): Array<TableElement> {
        const elements = {
            'td-pos': player.positionName,
            'td-name': player.name,
            'td-salary': player.getSalaryByMode(),
            'td-odds': player.points,
            'td-rating': player.grades,
            'td-fpts': player.getFptsPerSalary(),
            'td-fpts-per-salary': player.getUserPointsByMode(),
            'td-pown': player.projOwn.getValue(),
            '': this.getSwapButton(salaryCapExceeded, substitutablePlayer, player, lineup),
        };

        return this.buildRow(elements);
    }
}
